import { service } from '../../../../helpers/http'

export const ActionIndexVacancyControl = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'roomAllocation', 
		action: 'indexVacancyControl', 
		payload: payload 
	})
}